import {
  Table,
  TableBody,
  TableCell,
  TableHead,
  TableHeader,
  TableRow,
} from "@/components/ui/table";
import { Badge } from "@/components/ui/badge";
import { fmtNum, fmtDate } from "@/lib/format";
import { PAYMENT_TYPES } from "@/lib/calculations";

const typeBadge = (type) => {
  const map = {
    [PAYMENT_TYPES.ORG]: "bg-amber-50 text-amber-700 border-amber-200",
    [PAYMENT_TYPES.DOWN]: "bg-zinc-100 text-zinc-700 border-zinc-200",
    [PAYMENT_TYPES.PRE]: "bg-sky-50 text-sky-700 border-sky-200",
    [PAYMENT_TYPES.POST]: "bg-violet-50 text-violet-700 border-violet-200",
  };
  return map[type] || "bg-zinc-100 text-zinc-700";
};

export function PaymentTable({ rows }) {
  // Aylık Ödeme'yi yuvarlanmış kümülatif farkı olarak göster ki
  // "Aylık Ödeme" ile "Toplam Ödeme" sütunları birebir tutarlı olsun.
  let prevCum = 0;
  const displayAmounts = rows.map((r) => {
    if (r.cumulative === null) return r.amount; // organizasyon satırı
    const cur = Math.round(r.cumulative);
    const amt = cur - prevCum;
    prevCum = cur;
    return amt;
  });

  return (
    <div
      className="bg-white rounded-2xl border border-zinc-200/60 shadow-sm overflow-hidden"
      data-testid="table-odeme-plani"
    >
      <div className="p-6 border-b border-zinc-100 flex items-center justify-between">
        <h2 className="font-heading text-lg font-semibold tracking-tight">
          Ödeme Planı
        </h2>
        <span className="text-xs text-zinc-400">{rows.length} satır</span>
      </div>
      <div className="overflow-x-auto">
        <Table>
          <TableHeader>
            <TableRow className="hover:bg-transparent border-zinc-100">
              <TableHead className="text-[11px] uppercase tracking-wide text-zinc-400">Dönem</TableHead>
              <TableHead className="text-[11px] uppercase tracking-wide text-zinc-400">Taksit Tarihi</TableHead>
              <TableHead className="text-[11px] uppercase tracking-wide text-zinc-400 text-right">Aylık Ödeme</TableHead>
              <TableHead className="text-[11px] uppercase tracking-wide text-zinc-400 text-right">Toplam Ödeme</TableHead>
              <TableHead className="text-[11px] uppercase tracking-wide text-zinc-400 text-right">Kalan Borç</TableHead>
              <TableHead className="text-[11px] uppercase tracking-wide text-zinc-400">Ödeme Türü</TableHead>
            </TableRow>
          </TableHeader>
          <TableBody>
            {rows.map((r, i) => (
              <TableRow
                key={i}
                data-testid={`plan-row-${r.period}`}
                className={`border-zinc-100 ${
                  r.isDeliveryMonth
                    ? "bg-[rgba(255,90,95,0.06)] border-l-4 border-l-[#FF5A5F]"
                    : "hover:bg-zinc-50/60"
                }`}
              >
                <TableCell className="font-medium tabular-nums">
                  {r.period}
                  {r.isDeliveryMonth && (
                    <span className="ml-2 text-[10px] font-semibold text-[#FF5A5F] uppercase">
                      Teslim Ayı
                    </span>
                  )}
                </TableCell>
                <TableCell className="tabular-nums text-zinc-600">
                  {fmtDate(r.date)}
                </TableCell>
                <TableCell
                  className="text-right tabular-nums font-medium"
                  data-testid={`amount-${r.period}`}
                >
                  {fmtNum(displayAmounts[i])}
                </TableCell>
                <TableCell className="text-right tabular-nums text-zinc-600">
                  {r.cumulative === null ? "—" : fmtNum(r.cumulative)}
                </TableCell>
                <TableCell className="text-right tabular-nums font-medium">
                  {fmtNum(r.remaining)}
                </TableCell>
                <TableCell>
                  <Badge
                    variant="outline"
                    className={`text-[10px] font-medium rounded-md ${typeBadge(
                      r.paymentType
                    )}`}
                  >
                    {r.paymentType}
                  </Badge>
                </TableCell>
              </TableRow>
            ))}
          </TableBody>
        </Table>
      </div>
    </div>
  );
}
